// src/Profile.tsx
import * as React from "react";
var Profile = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size * 1.25,
    height: props.size,
    viewBox: "0 0 20 16",
    fill: props.color,
    style: props.style,
    role: props.role,
    className: props.className
  },
  /* @__PURE__ */ React.createElement("path", { d: "M10 0C5.58 0 2 3.58 2 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zM6.06 13.02C6.4 12.3 8.5 11.6 10 11.6s3.61.7 3.94 1.42c-1.09.86-2.46 1.38-3.94 1.38s-2.86-.51-3.94-1.38zm9.03-1.16C13.94 10.47 11.17 10 10 10s-3.94.47-5.09 1.86A6.372 6.372 0 0 1 3.6 8c0-3.53 2.87-6.4 6.4-6.4s6.4 2.87 6.4 6.4c0 1.46-.5 2.79-1.31 3.86zM10 3.2C8.45 3.2 7.2 4.45 7.2 6c0 1.55 1.25 2.8 2.8 2.8s2.8-1.25 2.8-2.8c0-1.55-1.25-2.8-2.8-2.8zm0 4c-.66 0-1.2-.54-1.2-1.2s.54-1.2 1.2-1.2 1.2.54 1.2 1.2-.54 1.2-1.2 1.2z" })
);
Profile.displayName = "Profile";
export {
  Profile
};
